import { render } from "./humanityCourseManager.vue?vue&type=template&id=3c9fc79e&scoped=true"
import script from "./humanityCourseManager.vue?vue&type=script&lang=js"
export * from "./humanityCourseManager.vue?vue&type=script&lang=js"

import "./humanityCourseManager.vue?vue&type=style&index=0&id=3c9fc79e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9fc79e"]])

export default __exports__